import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { PreviewBlockNode } from 'libs/editor/plugins/nodes/blocks/preview';

import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

@observer
export class PreviewNode extends React.Component {
  render() {
    // Return block preview by now. Later on, we might want to use alternative styling
    return <PreviewBlockNode {...this.props} />;
  }
}

PreviewNode.propTypes = {
  attributes: PropTypes.object,
  node: PropTypes.object,
  isSelected: PropTypes.bool,
};

export function Preview() {
  return {
    plugins: [RenderNode('preview', props => <PreviewNode {...props} />)],
  };
}
